import { render, staticRenderFns } from "./LevelSelectionStep.vue?vue&type=template&id=5356a842&"
import script from "./LevelSelectionStep.vue?vue&type=script&lang=js&"
export * from "./LevelSelectionStep.vue?vue&type=script&lang=js&"
import style0 from "./LevelSelectionStep.vue?vue&type=style&index=0&id=5356a842&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports